import $ from "jquery";
import 'hammerjs';
import sqftConfig from "./sqftConfig";

const sqftEventManager = {
  renderEvents: [],
  renderEventsSlab: [],
  priorities: {
    OVERALL: -100,
    SLAB_RIGHT_PART_CONTENT: -40,
    SLAB_RIGHT_PART_WORKSPACE: -30,
    BOX_POINT: -5,
    BOX: -1,
    OVERLAY: 0,
    IMAGE_LINE: 1,
    IMAGE: 3,
    POINT: 5,
    SEGMENT_MEASUREMENTS: 7,
    SEGMENT: 10,
    SHAPE_LABEL: 12,
    SHAPE_UPPER: 14.5,
    SHAPE: 15,
    SHAPE_SLAB_PLACEHOLDER: 15.5,
    WALL: 18,
    SLAB_IMAGE: 20,
    SLAB_LEFT_PART: 25,
    WORKSPACE: 100,
  },
  events: {
    MOUSE_MOVE: "mousemove",
    MOUSE_DOWN: "mousedown",
    MOUSE_UP: "mouseup",
    MOUSE_WHEEL: "mousewheel",
    WHEEL: "wheel",
    ON_MOUSE_WHEEL: "onmousewheel",
    RESIZE: "resize",
    TOUCH_START: "touchstart",
    TOUCH_END: "touchend",
    TOUCH_MOVE: "touchmove",
    TOUCH_CANCEL: "touchcancel",
    MOUSE_LEAVE: "mouseleave",
    CLICK: "click",
    DBLCLICK: "dblclick",
    CONTEXTMENU: "contextmenu",
    KEYDOWN: "keydown",
    RENDER: "render",
    DRAG_OVER: "dragover",
    DROP: "drop"
  },
  keyCode: {
    ENTER: "Enter",
    NumpadEnter: "NumpadEnter"
  },
  self: this,
  activeEvents: [],
  canvas: null,
  $canvas: null,
  canvasOffset: null,
  ctx: null,
  state: {
    processing: false
  },
  eventQueue: [],
  G_events: { //events to tie into the Quoting Tool's Global Events for Idle timeout
    userIdleStartTimer: 'userIdleStartTimer',
    userIdleWarning: 'userIdleWarning',
    userIdleTimeOut: 'userIdleTimeOut',
    userIdleStopTimer: 'userIdleStopTimer',
    userIdleGoHome: 'userIdleGoHome',
    userIdleGoHomeCountdown: 'userIdleGoHomeCountdown'
  },
  hammerMC: null,
  LastKnownMousePos: null,
  currentCursorOwner: null,
  currentCursor: null,
  noCursorStealing: false,
  zoomLock: null,
  resizeHandler: null,
  keydownHandler: null,

  getCtx: function() {
    return this.ctx
  },
  eventSort: function (a, b) {
    if (a.priority < b.priority)
      return -1;
    if (a.priority > b.priority)
      return 1;
    return 0;
  },
  getMousePos: function (e) {
    if (!e) {
      return this.LastKnownMousePos;
    }
    this.LastKnownMousePos = {
      x: e.pageX - this.canvasOffset.left,
      y: e.pageY - this.canvasOffset.top
    };
    return this.LastKnownMousePos;
  },
  getTouchPos: function (e) {
    var touch = e.changedTouches[0];
    if (!touch) {
      return null;
    }
    this.LastKnownMousePos = {
      x: touch.pageX - this.canvasOffset.left,
      y: touch.pageY - this.canvasOffset.top
    };
    return this.LastKnownMousePos;
  },
  setCanvas: function(value) {
    this.canvas = value;
    this.$canvas = $(value);
    this.ctx = this.canvas.getContext('2d');
  },
  onMouseMove: function(mousepos, e) {
    let mousemove = this.activeEvents[this.events.MOUSE_MOVE] || [];
    e.terminate = false;
    for (var i = 0; i < mousemove.length; i++) {
      if (mousemove[i].event.call(mousemove[i].sender, mousepos, e)) {
        e.terminate = true;
      }
    }
  },
  onMouseUp: function(mousepos, e) {
    var mouseup = this.activeEvents[this.events.MOUSE_UP] || [];
    for (var i = 0; i < mouseup.length; i++) {
      if (mouseup[i].event.call(mouseup[i].sender, mousepos, e)) {
        break;
      }
    }
  },
  onMouseDown: function(mousepos, e, callback) {
    var mousedown = this.activeEvents[this.events.MOUSE_DOWN] || [];
    for (var i = 0; i < mousedown.length; i++) {
      if (mousedown[i].event.call(mousedown[i].sender, mousepos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousepos, e);
    }
  },
  onMouseLeave: function(mousepos, e, callback) {
    var mouseleave = this.activeEvents[this.events.MOUSE_LEAVE] || [];
    for (var i = 0; i < mouseleave.length; i++) {
      if (mouseleave[i].event.call(mouseleave[i].sender, mousepos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousepos, e);
    }
  },
  onKeyDown: function (code, e, callback) {
    let mouseleave = this.activeEvents[this.events.KEYDOWN] || [];
    for (let i = 0; i < mouseleave.length; i++) {
      if (mouseleave[i].event.call(mouseleave[i].sender, code, e)) {
        e.preventDefault();
        e.stopPropagation();
        break;
      }
    }
    if (callback) {
      callback(code, e);
    }
  },
  onDblClick: function(mousepos, e, callback) {
    let mousedown = this.activeEvents[this.events.DBLCLICK] || [];
    for (let i = 0; i < mousedown.length; i++) {
      if (mousedown[i].event.call(mousedown[i].sender, mousepos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousepos, e);
    }
  },
  onWheel: function(mousePos, e, callback) {
    let wheel = this.activeEvents[this.events.WHEEL] || [];
    for (let i = 0; i < wheel.length; i++) {
      if (wheel[i].event.call(wheel[i].sender, mousePos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousePos, e);
    }
  },
  onResize: function(e) {
    let resize = this.activeEvents[this.events.RESIZE] || [];
    for (let i = 0; i < resize.length; i++) {
      if (resize[i].event.call(resize[i].sender, e)) {
        break;
      }
    }
    this.updateOffset(e);
  },
  onContextmenu: function(mousePos, e, callback) {
    let contextmenu = this.activeEvents[this.events.CONTEXTMENU] || [];
    for (let i = 0; i < contextmenu.length; i++) {
      if (contextmenu[i].event.call(contextmenu[i].sender, mousePos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousePos, e);
    }
  },
  onDrop: function(mousePos, e, callback) {
    let dragEvents = this.activeEvents[this.events.DROP] || [];
    for (let i = 0; i < dragEvents.length; i++) {
      if (dragEvents[i].event.call(dragEvents[i].sender, mousePos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousePos, e);
    }
  },
  onDragOver: function(mousePos, e, callback) {
    let dragOverEvents = this.activeEvents[this.events.DRAG_OVER] || [];
    for (let i = 0; i < dragOverEvents.length; i++) {
      if (dragOverEvents[i].event.call(dragOverEvents[i].sender, mousePos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousePos, e);
    }
  },
  onTouchCancel: function() {
    onMouseUp(this.LastKnownMousePos, {});
    this.LastKnownMousePos = {x: 0, y: 0};
    onMouseMove(this.LastKnownMousePos, {});
  },
  onRender: function() {
    var render = this.activeEvents[this.events.RENDER] || [];
    var triangles = [];
    for (var i = render.length - 1; i >= 0; i-- ) {
      if (render[i] === undefined) {
        continue
      }
      var result = render[i].event.call(render[i].sender, this.ctx);
      if (render[i] !== undefined && render[i].priority === this.priorities.SHAPE) {
        triangles.push(result);
      }
    }
    return triangles;
  },
  updateOffset: function() {
    this.canvasOffset = $(this.canvas).offset();
  },
  trigger: function(event, e) {
    let response = null;
    switch(event) {
      case this.events.MOUSE_MOVE:
      case this.events.TOUCH_MOVE:
        response = this.onMouseMove(this.getMousePos(e), e);
        break;
      case this.events.MOUSE_WHEEL:
      case this.events.WHEEL:
      case this.events.ON_MOUSE_WHEEL:
        console.log("WHEEL");
        break;
      case this.events.MOUSE_UP:
      case this.events.TOUCH_END:
        response = this.onMouseUp(this.getMousePos(e), e);
        break;
      case this.events.MOUSE_DOWN:
      case this.events.TOUCH_START:
        response = this.onMouseDown(this.getMousePos(e), e);
        break;
      case this.events.TOUCH_CANCEL:
        response = this.onTouchCancel();
        break;
      case this.events.RESIZE:
        response = this.onResize(e);
        break;
      case this.MOUSE_LEAVE:
        response = this.onMouseLeave(e);
        break;
      case this.CONTEXTMENU:
        response =  this.onContextmenu(this.getMousePos(e), e);
        break;
      case this.DBLCLICK:
        response = this.onDblClick(this.getMousePos(e), e);
        break;
      case this.events.RENDER:
        response = this.onRender();
        break;
    }
    return response;
  },
  pinchToZoom: function(event) {
    let stepSize = 0.04;
    let self = this;
    if (!this.zoomLock) {
      this.zoomLock = window.setTimeout(function() {
        self.zoomLock = null;
      }, 10);
      let scale = sqftConfig.scale,
        mod = 0;
      if (event.additionalEvent === "pinchin") {
        mod = -1;
      } else if (event.additionalEvent === "pinchout") {
        mod = 1;
      }
      if (mod !== 0) {
        scale += (mod * stepSize);
        if (scale < 1) {
          scale = 1;
        } else if (scale > 10) {
          scale = 10;
        }
        sqftConfig.scale = scale;
      }
    }
  },
  init: function(canvas) {
    if (this.canvas && this.canvas.isWithEventManager) {
      return;
    }
    let self = this;
    this.setCanvas(canvas);
    if (!this.hammerMC) {
      this.hammerMC = new Hammer.Manager(canvas);
      this.hammerMC.add(new Hammer.Pinch({enable: true}));
      this.hammerMC.on('pinch', this.pinchToZoom);
    }

    this.resizeHandler = this.onResize.bind(this);
    window.addEventListener(this.events.RESIZE, this.resizeHandler);

    this.keydownHandler = function (e) {
      // e.preventDefault();
      // e.stopPropagation();
      if (event.isComposing || event.keyCode === 229) {
        return;
      }

      console.log(e.code);
      this.eventQueue.push([this.events.KEYDOWN, e.code, e]);
      this.processEventQueue();
    }.bind(this);
    window.addEventListener(this.events.KEYDOWN, this.keydownHandler);

    canvas.addEventListener(this.events.MOUSE_MOVE, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.eventQueue.length > 2 &&
        this.eventQueue[this.eventQueue.length - 1][0] === self.events.MOUSE_MOVE &&
        this.eventQueue[this.eventQueue.length - 2][0] === self.events.MOUSE_MOVE
      ) {
        this.eventQueue[this.eventQueue.length - 1] = [self.events.MOUSE_MOVE, this.getMousePos(e), e];
      } else {
        this.eventQueue.push([self.events.MOUSE_MOVE, this.getMousePos(e), e]);
      }
      this.processEventQueue();
    }.bind(this));
    canvas.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.eventQueue.push([self.events.DRAG_OVER, this.getMousePos(e), e]);
      this.processEventQueue();
    }.bind(this));
    canvas.addEventListener('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.eventQueue.push([self.events.DROP, this.getMousePos(e), e]);
      this.processEventQueue();
    }.bind(this));
    canvas.addEventListener(self.events.MOUSE_DOWN, function(e){
      e.preventDefault();
      e.stopPropagation();
      if (!e.handled) {
        this.eventQueue.push([self.events.MOUSE_DOWN, this.getMousePos(e), e]);
        this.processEventQueue();
      }
    }.bind(this));
    canvas.addEventListener(this.events.MOUSE_UP, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!e.handled) {
        this.eventQueue.push([self.events.MOUSE_UP, this.getMousePos(e), e]);
        this.processEventQueue();
      }
    }.bind(this));
    canvas.addEventListener(this.events.TOUCH_START, function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.handled = true;
      if (e.touches.length === 1) {
        let touchPos = self.getTouchPos(e);
        this.eventQueue.push([self.events.MOUSE_MOVE, touchPos, e]);
        this.eventQueue.push([self.events.TOUCH_START, touchPos, e]);
        this.processEventQueue();
      }
    }.bind(this), { passive: false });
    canvas.addEventListener(this.events.TOUCH_END, function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.handled = true;
      this.eventQueue.push([self.events.TOUCH_END, this.getTouchPos(e), e]);
      this.processEventQueue();
    }.bind(this), { passive: false });
    canvas.addEventListener(this.events.TOUCH_CANCEL, function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.eventQueue.push([self.events.TOUCH_CANCEL, this.getTouchPos(e), e]);
      this.processEventQueue();
    }.bind(this), { passive: false });
    canvas.addEventListener(this.events.TOUCH_MOVE, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (self.zoomLock || e.touches.length > 1) //do not move when multi-touch or zoom locked or if the finger-move jumps too far
        return;
      let touchPos = self.getTouchPos(e);
      if (self.eventQueue.length > 2 &&
        self.eventQueue[self.eventQueue.length - 1][0] === self.events.TOUCH_MOVE &&
        self.eventQueue[self.eventQueue.length - 2][0] === self.events.TOUCH_MOVE
      ) {
        self.eventQueue[self.eventQueue.length - 1] = [self.events.TOUCH_MOVE, self.getTouchPos(e), e];
      } else {
        self.eventQueue.push([self.events.TOUCH_MOVE, touchPos, e]);
      }
      self.processEventQueue();
    }.bind(this), { passive: false });
    canvas.addEventListener(this.events.MOUSE_LEAVE, function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.eventQueue.push([self.events.MOUSE_LEAVE, this.getMousePos(e), e]);
      this.processEventQueue();
    }.bind(this));
    canvas.addEventListener(this.events.DBLCLICK, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!e.handled) {
        this.eventQueue.push([self.events.DBLCLICK, this.getMousePos(e), e]);
        this.processEventQueue();
      }
    }.bind(this));
    canvas.addEventListener(this.events.WHEEL, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!e.handled) {
        this.eventQueue.push([self.events.WHEEL, this.getMousePos(e), e]);
        this.processEventQueue();
      }
    }.bind(this));
    canvas.addEventListener(this.events.CONTEXTMENU, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!e.handled) {
        this.eventQueue.push([self.events.CONTEXTMENU, this.getMousePos(e), e]);
        this.processEventQueue();
      }
    }.bind(this));
    this.updateOffset();
    this.resetCursor(null);
    this.canvas.isWithEventManager  = true;
  },
  clearAll: function() {
    window.removeEventListener(this.events.RESIZE, this.resizeHandler);
    window.removeEventListener(this.events.KEYDOWN, this.keydownHandler);

    this.activeEvents = [];
    this.eventQueue = [];
    this.LastKnownMousePos = {
      x: -1,
      y: -1
    };
  },
  stealCursor: function(override, revertBackAfterMouseUp) {
    if (override && this.currentCursorOwner) {
      if (this.currentCursorOwner.destroy) {
        this.currentCursorOwner.destroy(true, revertBackAfterMouseUp);
      }
    }
    if (!this.noCursorStealing || override) {
      this.resetCursor(this.currentCursorOwner);
    }
  },
  releaseStealLock: function(owner) {
    if (this.currentCursorOwner === owner) {
      this.noCursorStealing = false;
    }
  },
  setCursor: function(cursor, owner, noStealing) {
    this.noCursorStealing = noStealing || this.noCursorStealing;
    if (this.currentCursorOwner === null || this.currentCursorOwner === owner) {
      if (this.currentCursor !== cursor) {
        var prefix = "cursor-";
        var classes = this.canvas.className.split(" ").filter(function(c) {
          return c.lastIndexOf(prefix, 0) !== 0;
        });
        this.canvas.className = $.trim(classes.join(" "));
        $(this.canvas).addClass("cursor-" + cursor);
        $(this.canvas).css({cursor: null});
        this.currentCursorOwner = owner;
        this.currentCursor = cursor;
      }
    }
  },
  setCursorImage: function(cursorImage, owner, noStealing) {
    this.setCursor("image", owner, noStealing);
    $(this.canvas).css({cursor: "url(" + cursorImage + "), default !important"});
  },
  resetCursor: function(owner) {
    if (this.currentCursorOwner === owner) {
      this.currentCursorOwner = null;
      this.setCursor("grab", null);
      this.releaseStealLock(owner);
    }
  },
  getCursor: function() {
    var prefix = "cursor-";
    var classes = this.canvas.className.split(" ").filter(function(c) {
      return c.lastIndexOf(prefix, 0) === 0;
    });
    for (var i = 0; i < classes.length; i++) {
      classes[i] = classes[i].replace(prefix, "");
    }
    return classes;
  },
  event: function(callback, sender, priority) {
    this.event = callback;
    this.sender = sender;
    this.priority = priority;
  },
  addEvent: function(event, callback, sender, priority) {
    var e = new this.event(callback, sender, priority);
    this.activeEvents[event] = this.activeEvents[event] || [];
    this.activeEvents[event].unshift(e);
    this.activeEvents[event].sort(this.eventSort);
  },
  removeEvent: function(sender, event) {
    let i;
    if (typeof(event) === 'undefined') {
      event = null;
    } else {
      event = event.toLowerCase();
    }
    if (event === null) {
      for (var key in this.activeEvents) {
        for (i = this.activeEvents[key].length -1; i >= 0; i--) {
          // lodash compare variant
          // if (_.isEqual(this.activeEvents[key][i].sender, sender)) {
          if (this.activeEvents[key][i].sender === sender) {
            this.activeEvents[key].splice(i, 1);
          }
        }
      }
    } else if (this.activeEvents[event] !== null) {
      for (i = this.activeEvents[event].length - 1; i >= 0; i--) {
        if (this.activeEvents[event][i].sender === sender) {
          this.activeEvents[event].splice(i, 1);
        }
      }
    }
  },
  removeStuckCursorEvents: function() {
    let mouseupEvents = this.activeEvents[this.events.MOUSE_UP] || [];
    for (const mouseupEvent of mouseupEvents) {
      const isCursorExist = mouseupEvent.sender.cursorImage || mouseupEvent.sender.cursor;
      if (isCursorExist && mouseupEvent.sender && mouseupEvent.sender.destroy) {
        mouseupEvent.sender.destroy(true, false);
      }
    }
  },
  processEventQueue: function() {
    if (!this.state.processing) {
      this.state.processing = true;
      let e;
      while( (e = this.eventQueue.shift()) ) {
        if (e[1] == null) {
          continue;
        }
        switch(e[0]) {
          case this.events.MOUSE_DOWN:
          case this.events.TOUCH_START:
            this.onMouseDown(e[1], e[2]);
            break;
          case this.events.MOUSE_MOVE:
          case this.events.TOUCH_MOVE:
            this.onMouseMove(e[1], e[2]);
            break;
          case this.events.MOUSE_UP:
          case this.events.TOUCH_END:
            this.onMouseUp(e[1], e[2]);
            break;
          case this.events.DBLCLICK:
            this.onDblClick(e[1], e[2]);
            break;
          case this.events.TOUCH_CANCEL:
            this.onTouchCancel();
            break;
          case this.events.MOUSE_LEAVE:
            this.onMouseLeave(e[1], e[2]);
            break;
          case this.events.RESIZE:
            this.onResize(e[1], e[2]);
            break;
          case this.events.MOUSE_WHEEL:
          case this.events.WHEEL:
          case this.events.ON_MOUSE_WHEEL:
            this.onWheel(e[1], e[2]);
            break;
          case this.events.KEYDOWN:
            this.onKeyDown(e[1], e[2]);
            break;
          case this.events.CONTEXTMENU:
            this.onContextmenu(e[1], e[2]);
            break;
          case this.events.DRAG_OVER:
            this.onDragOver(e[1], e[2]);
            break;
          case this.events.DROP:
            this.onDrop(e[1], e[2]);
            break;
        }
      }
    }
    this.state.processing = false;
    //window.resetIdleTimer(); //todo sqft-react is this needed
  }
};

export default sqftEventManager
